// extracted by mini-css-extract-plugin
module.exports = {"Main":"MainPage_Main__35SG2"};